import type { Theme } from "@mui/material/styles";
import { FACILITY_REPORT_MAP_LOCATION_AUTOCOMPLETE_FULLSCREEN_Z_INDEX } from "./functions/facility-report.functions";

/** `z-index` for the fixed map location autocomplete when the map is not in browser fullscreen. */
export const MAP_LOCATION_AUTOCOMPLETE_Z_INDEX_DEFAULT = 1000;

export function facilityReportMapLocationTextFieldSx(theme: Theme) {
  return {
    bgcolor: theme.palette.common.white,
    "& .MuiInputLabel-root": {
      color: theme.palette.common.black,
      "&.Mui-focused": { color: theme.palette.common.black },
      "&.Mui-disabled": { color: theme.palette.action.disabled }
    },
    "& .MuiOutlinedInput-root": {
      bgcolor: theme.palette.common.white,
      color: theme.palette.common.black,
      "&.Mui-disabled": {
        color: theme.palette.action.disabled,
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: theme.palette.action.disabledBackground
        }
      },
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: theme.palette.grey[400]
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: theme.palette.common.black
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: theme.palette.common.black,
        borderWidth: "1px"
      }
    },
    "& .MuiOutlinedInput-input": {
      color: theme.palette.common.black,
      "&::placeholder": {
        color: theme.palette.grey[700],
        opacity: 1
      }
    },
    "& .MuiAutocomplete-endAdornment .MuiIconButton-root": {
      color: theme.palette.common.black
    },
    "& .MuiAutocomplete-endAdornment .MuiSvgIcon-root": {
      color: theme.palette.common.black
    }
  };
}

export function facilityReportMapLocationPaperSx(theme: Theme) {
  return {
    bgcolor: theme.palette.common.white,
    color: theme.palette.common.black,
    "& .MuiAutocomplete-option": { color: theme.palette.common.black }
  };
}

export type FacilityReportMapLocationAutocompleteRootSxArgs = {
  theme: Theme;
  isMobile: boolean;
  isMapFullscreen: boolean;
  topCss: string;
  leftPx: number;
};

export function facilityReportMapLocationAutocompleteRootSx(
  args: FacilityReportMapLocationAutocompleteRootSxArgs
) {
  const { theme, isMobile, isMapFullscreen, topCss, leftPx } = args;

  return {
    position: "fixed" as const,
    zIndex: isMapFullscreen
      ? FACILITY_REPORT_MAP_LOCATION_AUTOCOMPLETE_FULLSCREEN_Z_INDEX
      : MAP_LOCATION_AUTOCOMPLETE_Z_INDEX_DEFAULT,
    bgcolor: theme.palette.common.white,
    boxShadow: theme.shadows[1],
    top: topCss,
    ...(isMobile
      ? {
          left: theme.spacing(2),
          right: theme.spacing(2),
          width: "auto",
          minWidth: 0,
          maxWidth: "100%"
        }
      : {
          left: `${leftPx}px`,
          minWidth: 250
        })
  };
}
